<template>
  <div>
    <div v-if="show" class="wxPage">
      <div class="back" @click="onClose" />
      <div class="font" @click="onClose">点击这里分享<i class="iconfont iconjiantouShare" /></div>
    </div>

  </div>
</template>
<script>
import request from '@/utils/request'
import wx from 'weixin-js-sdk'
import { MyNotify } from '@/utils/base'
import { unwatchFile } from 'fs'
import globalVariable from '@/api/global_variable.js'
import { GetSelfUrl } from '@/utils/request'
export default {
  components: {
  },
  props: {
    value: Boolean,
    // eslint-disable-next-line
    title: {
      default: '测试'
    },
    // eslint-disable-next-line
    desc: {
      default: '测试描述'
    },
    // eslint-disable-next-line
    timeline:{
      default: '朋友圈'
    },
    // eslint-disable-next-line
    img: {
      default: undefined
    },
    // eslint-disable-next-line
    url: {
      default: undefined
    }
  },
  data() {
    return {
      show: false,
      tryNum: 0
    }
  },
  watch: {
    img(newValue) {
      console.log('我监听到了img的值')
      console.log('img', newValue)
    },
    url(newValue) {
      console.log('我监听到了url的值')
      console.log('img', newValue)
    },
    value(newValue, oldValue) {
      if (newValue) {
        this.show = true
      }
    }
  },
  created() {
    var my = this
    setTimeout(() => {
      my.tryInit(my)
    }, 100)
  },
  methods: {
    onClose() {
      this.show = false
      this.$emit('input', false)
    },
    tryInit(my) {
      my.tryNum++
      if (my.url) {
        my.init(my)
        return
      }
      if (my.tryNum > 1000) {
        return
      }
      setTimeout(() => {
        my.tryInit(my)
      }, 100)
    },
    init(my) {
      var url = location.href.split('#')[0]
      if (window.__wxjs_is_wkwebview) {
        var baseurl = GetSelfUrl()
        url = baseurl.substring(0, baseurl.length - 1) + globalVariable.IosStartURL
        //alert("我是IOS系统，入口页面地址为:"+url)
      }
      request({
        url: '/Activity/getWxShare',
        method: 'post',
        data: {
          url: url
        }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        // alert("Response.data.appId："+Response.data.appId)
        // alert("Response.data.timestamp："+Response.data.timestamp)
        // alert("Response.data.nonceStr："+Response.data.nonceStr)
        // alert("Response.data.signature："+Response.data.signature)
        var wxconfig = {
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: Response.data.appId, // 必填，公众号的唯一标识
          timestamp: Number(Response.data.timestamp), // 必填，生成签名的时间戳
          nonceStr: Response.data.nonceStr, // 必填，生成签名的随机串
          signature: Response.data.signature, // 必填，签名，见附录1
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        }
        console.log('aaaaaa', wxconfig)
        wx.config(wxconfig)
      })
      wx.ready(function() {
        var links = my.url
        var title = my.title
        var desc = my.desc
        var imgUrl = my.img
        var timeline = my.timeline
        var successcallback = function() {
          MyNotify('success', '分享成功')
          my.onClose()
        }
        var cancelcallback = function() {
          my.onClose()
        }
        wx.onMenuShareTimeline({
          title: timeline, // 分享标题
          link: links, // 分享链接,将当前登录用户转为puid,以便于发展下线
          imgUrl: imgUrl, // 分享图标
          success: successcallback,
          cancel: cancelcallback
        })
        wx.onMenuShareAppMessage({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: links, // 分享链接
          imgUrl: imgUrl, // 分享图标
          type: 'link', // 分享类型,music、video或link，不填默认为link
          success: successcallback,
          cancel: cancelcallback
        })
        wx.onMenuShareQQ({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: links, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: successcallback,
          cancel: cancelcallback
        })
        wx.onMenuShareWeibo({
          title: title, // 分享标题
          desc: desc, // 分享标题
          link: links, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: successcallback,
          cancel: cancelcallback
        })
        wx.onMenuShareQZone({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: links, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: successcallback,
          cancel: cancelcallback
        })
      })
    }
  }
}
</script>
<style scoped>
.wxPage{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
}
.wxPage .back{
    width: 100%;
    height: 100%;
    background-color: #000 ;
    -moz-opacity:0.8;
    opacity: 0.8;
}
.font{
    position: fixed;
    right: 1em;
    top: 1em;
     z-index: 10000;
     color: #fff;
}
.font i{
    font-size: 4em;
}
</style>
